import { render, staticRenderFns } from "./child-ring.vue?vue&type=template&id=7427b637&scoped=true"
import script from "./child-ring.vue?vue&type=script&lang=js"
export * from "./child-ring.vue?vue&type=script&lang=js"
import style0 from "./child-ring.vue?vue&type=style&index=0&id=7427b637&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7427b637",
  null
  
)

export default component.exports